import React from 'react';
import useGlobalStyles from 'hooks/useGlobalStyles';
import { Card, CardContent, Grid, Typography, makeStyles, Button } from '@material-ui/core';
import { Spacing, Icon } from 'components';
import { COLORS } from 'constants/index';

interface MessageAction {
  label: string;
  href?: string;
  onClick?: () => void;
}

interface Props {
  actions?: MessageAction[];
  body: string | JSX.Element;
  icon: JSX.Element;
};

const useStyles = makeStyles({
  root: {
    boxShadow: 'none',
    maxWidth: '418px'
  },
  content: {
    backgroundColor: COLORS.BLUE_50
  },
  buttonContainer: {
    '& .MuiButton-textPrimary': {
      backgroundColor: COLORS.BLUE_50,
      color: COLORS.BLUE,
    }
  }
})

const MessageCard: React.SFC<Props> = (props) => {
  const { actions, body, icon } = props;
  const globalClasses = useGlobalStyles();
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <CardContent className={classes.content}>
        <Grid container spacing={1}>
          <Icon>
            {icon}
          </Icon>
          <Grid item sm={9} xs={8}>
            <Typography variant="body2" style={{color: COLORS.BLACK_6}}>
              {body}
            </Typography>
          </Grid>
          {actions && (
            <Grid item xs={12}>
              <Grid className={[globalClasses.buttonContainer, classes.buttonContainer].join(' ')} container>
                <Grid item xs={3} />
                <Grid item sm={9} xs={9} style={{ textAlign: 'right' }}>
                  <div className={globalClasses.actionButtonGroup}>
                    {actions.map(({ label, href, onClick }: MessageAction) => (
                      <Button
                        key={label}
                        color="primary"
                        variant="text"
                        href={href}
                        onClick={onClick}
                      >
                        {label}
                      </Button>
                    ))}
                  </div>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      </CardContent>
      <Spacing height="1px" style={{ background: COLORS.GRAY_08 }} />
    </Card>
  );
}

export default MessageCard;
